<ng-container *transloco="let t">
  <div class="admin-card">
    <app-admin-actions-header (onExportToPdf)="downloadLeagues('pdf')"
                              (onExportToXls)="downloadLeagues('xlsx')">
      <div slot="leadingWidgets">
      </div>
      <div slot="trailingWidgets">
        <div class="pe-3">
          <app-rounded-button [label]="t('leagues.add.new.league')" (click)="goToAddLeague()"><i
            class="bi bi-plus-circle pe-2"></i></app-rounded-button>
        </div>
      </div>
    </app-admin-actions-header>
    <div>
      @if ((leagues.length ?? 0) > 0) {
        <!-- Desktop -->
        <div>
          <div class="table-responsive dark-header d-xl-block d-none">
            <app-sortable-table [infiniteScrollDistance]="4" cssClass="table table-last-row-no-border" infinite-scroll
                                [items]="leagues">
              <thead>
              <tr>
                <th scope="col" [sortBy]="['id']" class="id-column-width">{{ t("league.id") }}</th>
                <th scope="col" [sortBy]="['name']">{{ t("league.name") }}</th>
                @if (authService.isAdminstrator()) {
                  <th [sortBy]="['organiser.name']">
                    {{ t("league.organiser.name") }}
                  </th>
                }
                <th scope="col" [sortBy]="['dateCreated']" data-type="date" class="date-column-width">{{ t("league.dateCreated") }}</th>
                <th class="more-column-width"></th>
              </tr>
              </thead>
              <tr app-table-header-separator></tr>
              <tbody>
                @for (league of leagues;track league) {
                  <tr>
                    <td class="center-align">{{ league.id }}</td>
                    <td class="center-align">
                      <app-language-output [hrLabel]="league?.name" [enLabel]="league?.nameEng"
                                           [itLabel]="league?.nameIta"
                                           [srLabel]="league?.nameSr"
                                           [bsLabel]="league?.nameBs"
                                           [siLabel]="league?.nameSlo" [languages]="languages"/>
                    </td>
                    @if (authService.isAdminstrator()) {
                      <td class="center-align">{{ league.organiser?.name }}</td>
                    }
                    <td class="center-align">{{ league.created | localizedDate:'short' }}</td>

                    <td class="text-end center-align">
                      <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                  <span class="menu-icon" id="eventActionsDropdown" ngbDropdownToggle>
                    <i class="fas fa-ellipsis-v"></i>
                  </span>
                        <ul aria-labelledby="eventActionsDropdown" ngbDropdownMenu>
                          <li ngbDropdownItem (click)="goToLeagueDetails(league)">{{
                              t("app.common.details")
                            }}
                          </li>
                          <li ngbDropdownItem (click)="openDeleteLeagueDialog(league)">
                            {{ t("app.common.delete") }}
                          </li>
                        </ul>
                      </div>
                    </td>

                  </tr>
                }
              </tbody>
            </app-sortable-table>
          </div>
          <!-- Mobile -->
          @for (league of leagues;let isLast = $last;track league) {
            <div class="d-block d-xl-none">
              <div [class.isLastRow]="isLast" class="d-flex justify-content-center align-items-center mobile-table-row">
                <div class="flex-grow-1">
                  <div [class.isLastRow]="isLast" class="d-flex flex-column">
                    <div>
                      <strong>{{ t("league.id") }}:</strong>{{ league.id }}
                    </div>
                    <div>
                      <strong>{{ t("league.name") }}:</strong>
                      <app-language-output [hrLabel]="league?.name" [enLabel]="league?.nameEng"
                                           [itLabel]="league?.nameIta"
                                           [bsLabel]="league?.nameBs"
                                           [srLabel]="league?.nameSr"
                                           [siLabel]="league?.nameSlo" [languages]="languages"/>
                    </div>
                    @if (authService.isAdminstrator()) {
                      <div>
                        <strong>{{ t("league.organiser.name") }}:</strong>{{ league.organiser?.name }}
                      </div>
                    }
                    <div>
                      <strong>{{ t("league.dateCreated") }}
                        :</strong>{{ league.created | localizedDate:'short' }}
                    </div>
                  </div>
                </div>
                <div>
                  <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                <span class="menu-icon" id="eventActionsDropdownMobile" ngbDropdownToggle>
                  <i class="fas fa-ellipsis-v"></i>
                </span>
                    <ul aria-labelledby="eventActionsDropdownMobile" ngbDropdownMenu>
                      <li ngbDropdownItem (click)="goToLeagueDetails(league)">{{
                          t("app.common.details")
                        }}
                      </li>
                      <li ngbDropdownItem (click)="openDeleteLeagueDialog(league)">{{
                          t("app.common.delete")
                        }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="pt-2 pb-4">
          <app-empty-state/>
        </div>
      }
    </div>
  </div>
</ng-container>

